import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SantanderBannerComponent } from './santander-banner.component';

@NgModule({
    declarations: [SantanderBannerComponent],
    imports: [CommonModule],
    exports: [SantanderBannerComponent]
})
export class SantanderBannerModule { }
